<template>
    <div v-if="showFlashMessage" class="absolute w-full" style="top: 0;">
        <div  v-if="type==='error'" class="bg-red-900 text-center py-4 lg:px-4 mt-16">
            <div class="p-2 bg-red-500 items-center text-white leading-none lg:rounded-full flex lg:inline-flex" role="alert">
                <span class="flex rounded-full bg-red-900 uppercase px-2 py-1 text-xs font-bold mr-3">ERROR</span>
                <span class="font-semibold mr-2 text-left flex-auto">{{ messageText }}</span>
                <svg class="fill-current opacity-75 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"/></svg>
            </div>
        </div>
        <div v-if="type==='success'" class="bg-green-600 text-center py-4 lg:px-4 mt-16">
            <div class="p-2 bg-green-400 items-center text-white leading-none lg:rounded-full flex lg:inline-flex" role="alert">
                <span class="flex rounded-full bg-green-600 uppercase px-2 py-1 text-xs font-bold mr-3">SUCCESS</span>
                <span class="font-semibold mr-2 text-left flex-auto">{{ messageText }}</span>
                <svg class="fill-current opacity-75 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"/></svg>
            </div>
        </div>
        <div v-if="type==='info'" class="bg-blue-600 text-center py-4 lg:px-4 mt-16">
            <div class="p-2 bg-blue-400 items-center text-white leading-none lg:rounded-full flex lg:inline-flex" role="alert">
                <span class="flex rounded-full bg-green-600 uppercase px-2 py-1 text-xs font-bold mr-3">INFO</span>
                <span class="font-semibold mr-2 text-left flex-auto">{{ messageText }}</span>
                <svg class="fill-current opacity-75 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.95 10.707l.707-.707L8 4.343 6.586 5.757 10.828 10l-4.242 4.243L8 15.657l4.95-4.95z"/></svg>
            </div>
        </div>
    </div>
</template>

<script>

    export default {

        data() {
            return {
                messageText: '',
                showFlashMessage: false,
            }
        },

        props: [
            'message',
            'type'
        ],

        methods: {

            flash(message) {
                this.messageText = message;
                this.showFlashMessage = true;
                this.hide();
            },

            hide() {
                setTimeout(() => {
                    /*console.log('Setting Flash Message to empty...');*/
                    this.showFlashMessage = false;
                    this.messageText = '';
                }, this.type === 'info' ? 2000 : 5000)
            }

        },

        created() {
            /*if(this.message && this.showFlashMessage) {
                this.flash(this.message);
            }*/

            if(this.message) {
                this.flash(this.message);
            }

            /*window.events.$on('flash', message => {
                this.flash(message);
            });*/
        }

    }

</script>
